export default __webpack_public_path__ + "static/media/Polyester.430c4eff.jpg";